export default "__VITE_ASSET__8cb27abb__"